import { Flex, Typography } from "antd";
import { FC } from "react";
import styled from "styled-components";
import { TaskPaidShelfSpace } from "tm-shared/types";

import { SubtaskCard, TaskViewModal } from "@/features/TaskView/components";

const StyledBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: ${({ theme }) => theme.primaryBackground};
    border-radius: 10px;
`;

interface PaidShelfSpaceViewModalProps {
    task: TaskPaidShelfSpace;
    onClose: () => void;
}

export const PaidShelfSpaceViewModal: FC<PaidShelfSpaceViewModalProps> = ({
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                {task.context.contracts.map((contract) => (
                    <StyledBlock key={contract.id}>
                        <Typography.Title level={5} style={{ margin: 0 }}>
                            {contract.name}
                        </Typography.Title>
                        {contract.description && (
                            <Typography.Paragraph
                                style={{ margin: 0, opacity: 0.8 }}
                            >
                                {contract.description}
                            </Typography.Paragraph>
                        )}
                    </StyledBlock>
                ))}

                <SubtaskCard subtask={taskPayload} title="Звіт по задачі" />
            </Flex>
        </TaskViewModal>
    );
};
